import {useState} from "react";
import {useLocation, useOutletContext, useParams} from "react-router-dom";
import {DepositoService} from "abastecemento/service";
import {deposito_view_adapter} from "abastecemento/model";
import {useNavigateWithReload} from "base/hooks";
import {EntityUpdatePanel} from "base/entity";
import {DepositoForm} from "../presentational/form";

const UpdateDepositoPanel = () => {
    const {section} = useParams();
    const location = useLocation();
    const baseLocationPath = location.pathname.split(section)[0];

    const [error, setError] = useState("");
    const navigate = useNavigateWithReload();

    let deposito;
    [deposito] = useOutletContext();

    const handleSubmit = deposito => {
        DepositoService.update(deposito_view_adapter({...deposito}))
            .then(() => {
                navigate(baseLocationPath, true);
            })
            .catch(error => {
                setError(error);
            });
    };

    const handleFormCancel = () => {
        navigate(baseLocationPath);
    };

    return (
        <EntityUpdatePanel
            form={
                <DepositoForm
                    deposito={deposito}
                    updatedSection={section}
                    onSubmit={handleSubmit}
                    onCancel={handleFormCancel}
                />
            }
            title="Modificar Depósito"
            error={error}
            onCancel={handleFormCancel}
        />
    );
};

export default UpdateDepositoPanel;
